import { FC } from 'react';
import { IonButton, IonContent } from '@ionic/react';
import { Modal } from '../components/Modal';

export const ContactPermissionsModal: FC<{
    isOpen?: boolean;
    onButtonClick: () => void;
    onClose?: () => void;
}> = ({
    isOpen = false,
    onButtonClick,
    onClose = () => {}
}) => {
    return (
        <Modal
            title=""
            isOpen={isOpen}
            desktopMinHeight={525}
            closeHandler={onClose}
            data-id="contact-permissions"
        >
            <IonContent>
                <div style={{marginLeft: 30, marginRight: 30}}>

                    <h1 style={{fontSize: 24}}>
                        Please select “Share All” to add from contacts
                    </h1>

                    <p style={{marginTop: 40, marginBottom: 50, marginRight: 10}}>
                        Innerhive will never share your contacts with any other party. This is only used to quickly add their info, and so that you don’t need to think of everyone you might want to add right now.
                    </p>

                    <div style={{maxWidth: 400, width: '100%', margin: 'auto'}}>
                        <img src="./assets/images/contacts/share-contacts.png" alt="Share All Contacts" />
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', gap: 10, position: 'fixed', bottom: 0, marginLeft: -25, marginBottom: 70, paddingLeft: 35, paddingRight: 35, width: '100%'}}>
                        <div style={{maxWidth: 400, width: '100%', margin: 'auto'}}>
                            <IonButton
                                expand="block"
                                fill="solid"
                                color="primary"
                                data-id="allow"
                                onClick={onButtonClick}
                            >
                                Continue
                            </IonButton>

                            <IonButton
                                expand="block"
                                fill="clear"
                                color="primary"
                                onClick={onClose}
                                data-id="later"
                            >
                                Maybe later
                            </IonButton>
                        </div>
                    </div>
                </div>
            </IonContent>
        </Modal>
    );
};
